import useNavigationStore from "@src/stores/navigationStore";
import EmailCheck from "./EmailCheck";
import Register from "./Register";
import Partner from "./Partner";

const componentMap = {
    Partner: Partner,
    EmailCheck: EmailCheck,
    Register: Register,
};

export default function FirstSection() {
    const { section } = useNavigationStore();

    const SelectedComponent = componentMap[section.block as keyof typeof componentMap] || null;

    return <>{SelectedComponent ? <SelectedComponent /> : null}</>;
}
